// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__N6X1r","right":"Footer_right__2TbvS","buttons":"Footer_buttons__-ui5-"};